export const buildStationUrl = (origin: string, station: string) => {
  const url = new URL('/', origin)
  url.searchParams.set('station', station)
  return url.toString()
}

export const resolvePublicOrigin = (currentOrigin: string, configuredOrigin?: string) => {
  if (!configuredOrigin?.trim()) return new URL(currentOrigin).origin
  try {
    const configured = new URL(configuredOrigin)
    return configured.protocol === 'https:' || configured.hostname === 'localhost' || configured.hostname === '127.0.0.1'
      ? configured.origin
      : new URL(currentOrigin).origin
  } catch {
    return new URL(currentOrigin).origin
  }
}

export const isLocalPublicOrigin = (origin: string) => {
  const hostname = new URL(origin).hostname
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1'
}
